import React from 'react';
import { useTranslation } from 'react-i18next';
import { ItemCreation } from '~/Components';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { ExtendedStaff } from './ExtendedSaff.model';
import { useStaffEdit } from './useStaffEdit';

export const StaffEdit = () => {
  const { t } = useTranslation();

  const {
    id,
    listItems,
    onSave,
    initialValues,
    validate,
    error,
    isLoading,
    isSubmitDisabled,
    fullName,
    onValidationErrors,
  } = useStaffEdit();

  return (
    <PrivateLayout
      title={id ? `${t('app.editing')} ${fullName}` : t('settings.provider.staff.inviteMember')}
      actionDisabled={isSubmitDisabled}
      actionName={t('app.save')}
      onActionTaken={onSave}
    >
      <ItemCreation<ExtendedStaff>
        listItems={listItems}
        headers={[]}
        onSave={onSave}
        initialValues={initialValues}
        validate={validate}
        networkError={error}
        isLoading={isLoading}
        onValidationErrors={onValidationErrors}
      />
    </PrivateLayout>
  );
};
